import React, { Component } from 'react';
import Header from '../header/Header';
import Text from '../Text';
import './Howto.css';

export default class Howto extends Component {
	render() {
		return (
            <div>
                <Header page="nav_howto" />
                <div class="howto">
                    <h3><Text>howto_headline_intro</Text></h3>
                    <div className="text-card">
                        <p><Text>howto_copy_intro_planning</Text></p>
                        <p><Text>howto_copy_intro_storypoints</Text></p>
                        <p><Text>howto_copy_intro_purpose</Text></p>
                    </div>

                    <h3><Text>howto_headline_instructions</Text></h3>
                    <div className="text-card">
                        <p><Text>howto_copy_instructions_setup</Text></p>
                        <p><Text>howto_copy_instructions_poker</Text></p>
                        <p><Text>howto_copy_instructions_disagreement</Text></p>
                    </div>

                    <h3><Text>howto_headline_complexity</Text></h3>
                    <div className="text-card">
                        <p><Text>howto_copy_complexity</Text></p>
                    </div>


                    <h3><Text>howto_headline_cards</Text></h3>
                    <div className="text-card">
                        <p><Text>howto_copy_cards</Text></p>
                        <ul>
                            <li><Text>howto_copy_cards_question</Text></li>
                            <li><Text>howto_copy_cards_coffee</Text></li>
                        </ul>
                    </div>
                </div>
            </div>

		);
	}
}



// WEBPACK FOOTER //
// ./src/howto/Howto.js